










import _ from "lodash";
import {Component} from "vue-property-decorator";
import Loading from "@/components/Loading.vue";
import VueError from "@/components/VueError.vue";
import Spinner from "@/components/Spinner.vue";
import {BssService, curBssService} from "@/services/BssService";
import {CnxTimeSeriesPoint} from "@/services/CoreClient";
import KeyValue from "@/components/KeyValue.vue";
import {ChartItem} from "chart.js";
import BaseStationChart from "@/components/bss/BaseStationChart.vue";
import BaseStationLineChart from "@/components/bss/BaseStationLineChart.vue";


@Component({
  components:{
    KeyValue,
    Loading,
    VueError,
    Spinner,
    BaseStationChart,
  }
})
export default class BaseStationCnxChart extends BaseStationLineChart {
  private bssService:BssService = curBssService;

  get id(): string {
    return `base-station-connection-chart-canvas-${this.lrrId}-${this.timeType}`;
  }

  mounted() {
    this.chartOptions.scales.yAxis.max = 1.5;
    this.chartOptions.scales.yAxis.min = 0;
    const ctx = document.getElementById(this.id);
    this.createChart(ctx as ChartItem);
  }

  protected calcInterval(range: string, origInterval: string): string {
    const rangeAsNumberOfDays = Number(range.slice(0, -1));
    let interval = '1m';
    if ( rangeAsNumberOfDays >= 30 ) {
      interval = '1h';
    } else if ( rangeAsNumberOfDays >= 15 ) {
      interval = '30m';
    } else if ( rangeAsNumberOfDays >= 5 ) {
      interval = '15m';
    }
    return interval;
  }

  protected calcIntervalFromStartFinish(startSec: number, finishSec: number): number {
    const rangeAsNumberOfDays = Math.floor((finishSec - startSec) / (24 * 3600) );
    let intervalSec = 60;
    if ( rangeAsNumberOfDays >= 30 ) {
      intervalSec = 60 * 60;
    } else if ( rangeAsNumberOfDays >= 15 ) {
      intervalSec = 30 * 60;
    } else if ( rangeAsNumberOfDays >= 5 ) {
      intervalSec = 15 * 60;
    }
    return intervalSec;
  }

  protected async fetchChartDataImpl(lrrId: string,
                                     start: number,
                                     finish: number,
                                     interval: number,
                                     timeType: string): Promise<any> {
    const dataFromDl = await this.getBaseStationCnx(lrrId, start, finish, interval);
    const ret = {
      labels: _.map(dataFromDl, item => item.ts),
      datasets: [{
        label: 'online status',
        backgroundColor: 'lightgreen',
        fill: 'origin',
        data: _.map(dataFromDl, item => item.onlineStatus),
      }]
    };
    return ret;
  }

  async getBaseStationCnx(lrrId:string,
                          start: number,
                          finish: number,
                          interval: number):Promise<CnxTimeSeriesPoint[]> {
    const reply = await this.bssService.getBaseStationCnxTimeSeries({
      lrrId,
      start,
      finish,
      interval,
    });
    return Promise.resolve(reply.timeSeries as CnxTimeSeriesPoint[]);
  }
}
